import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import FiltersIcon from "../../assets/icons/filter.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import BroadcastIcon from "../../assets/icons/prod_broadcast.svg2";
import MyBadge from "../Common/MyBadge";
import MySearch from "../Common/MySearch";
import { proxyAPI } from "../proxyAPI";
import BroadcastTemplateDetails from "./BroadcastTemplateDetails";
import BroadcastTemplateCard from "./BroadcastTemplateCard";
import MyPagination from "../Common/MyPagination";
import Subheading from "../Common/Subheading";
import { useNavigate } from "react-router-dom";
import HelpButton from "../HelpContent/HelpButton";
import { loadTagOptions } from "../helpers/loadTagOptions";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";

export default function BroadcastTemplateLibrary({ isModal }) {
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [totalResults, setTotalResults] = useState(18);
  const [availableTemplates, setAvailableTemplates] = useState([]);
  const [status, setStatus] = useState("");
  const [orderBy, setOrderBy] = useState("used-last");
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [folder, setFolder] = useState([]);
  const [pagination, setPagination] = useState({ page: 0, perPage: 12 });
  const [isLoading, setIsLoading] = useState(false);

  const loader = async () => {
    const [sortField, sortDirection] = orderBy.split("-");
    const orderByField = sortField === "used" ? "last_used" : `${sortField}_at`;
    const order = sortDirection === "first" ? "asc" : "desc";
    const tagsQuery = `${
      industry.length > 0 ? `&tags=industry:${industry.join(",")}` : ""
    }${category.length > 0 ? `&tags=category:${category.join(",")}` : ""}${
      folder.length > 0 ? `&tags=folder:${folder.join(",")}` : ""
    }`;

    setIsLoading(true);
    try {
      const data = await proxyAPI({
        prefix: "logic/workflows/api",
        url: `broadcasters?search=${search}&order_by=${orderByField}&order=${order}&status=${status}&offset=${
          pagination.page * pagination.perPage
        }&limit=${pagination.perPage}${tagsQuery}`,
      });
      if (data) {
        setAvailableTemplates(data.data);
        setTotalResults(data.total);
        setSelectedTemplate(data.data[0]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timeOut = setTimeout(() => {
      loader();
    }, 500);

    return () => {
      clearTimeout(timeOut);
    };
  }, [search]);

  useEffect(() => {
    loader();
  }, [orderBy, status, category, industry, folder, pagination]);

  return (
    <div>
      <FullScreenLoadingIndicator loading={isLoading} />
      <div className="d-flex justify-content-between ">
        <div className="d-flex align-items-center">
          <Subheading
            Icon={BroadcastIcon}
            heading="Broadcast Library"
            subheading="See your stored and pre-defined Broadcasts."
          />
        </div>
      </div>
      <div className="mb-3 bg-colored-reverse p-3 rounded-3 d-flex justify-content-between gap-3 align-items-end">
        <div className="">
          <FiltersIcon width={20} className="text-white" />
          <label className="fw-bold p-2 text-white">Filter options:</label>
          <div className="d-flex gap-3">
            <Input
              placeholder="Category"
              inputType="select"
              isMulti
              isClearable
              // isValidNewOption={(o) => o}
              loadOptions={loadTagOptions("category")}
              value={category}
              onChange={setCategory}
            />
            <Input
              placeholder="Industry"
              inputType="select"
              isMulti
              isClearable
              // isValidNewOption={(o) => o}
              loadOptions={loadTagOptions("industry")}
              value={industry}
              onChange={setIndustry}
            />
            <Input
              placeholder="Folder"
              inputType="select"
              isMulti
              isClearable
              // isValidNewOption={(o) => o}
              loadOptions={loadTagOptions("folder")}
              value={folder}
              onChange={setFolder}
            />
          </div>
        </div>

        <div>
          <label className="fw-bold p-2 text-white">Order by:</label>
          <Form.Select
            aria-label="newTemplate-select"
            onChange={(e) => {
              setOrderBy(e.target.value);
            }}
            value={orderBy}
          >
            <option value="created-last">Created Last</option>
            <option value="created-first">Created First</option>
            <option value="updated-first">Updated First</option>
            <option value="updated-last">Updated Last</option>
            <option value="used-last">Used Last</option>
            <option value="used-first">Used First</option>
          </Form.Select>
        </div>
        <div>
          <label className="fw-bold p-2 text-white">Status:</label>
          <Input
            value={[status]}
            onChange={(v) => {
              setStatus(v[0]);
            }}
            inputType="radio"
            options={[
              { value: "draft", label: "DRAFT" },
              { value: "published", label: "PUBLISHED" },
              { value: "archived", label: "ARCHIVED" },

              { value: "", label: "ALL" },
            ]}
          />
        </div>
        <div className="flex-grow-1"></div>
        <div className="">
          <label className="fw-bold p-2 text-white"></label>
          <MySearch
            placeholder="Search for a template"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>
      <Row className="mb-5 my-3 ">
        <Col xs={12} lg={4} className="pe-5 border-end border-2">
          <div
            style={{
              maxHeight: 500,
              overflowY: "auto",
              scrollbarColor: "purple",
            }}
            className="pe-2 fw-bold"
          >
            {" "}
            <div className="align-items-center">
              <span className="fs-3">
                Template Results <HelpButton helpKey="template-results" />
              </span>
              <MyBadge count={totalResults} />
            </div>
            {availableTemplates.map((template) => (
              <div
                key={template.Uuid}
                onDoubleClick={() => {
                  navigate(`/library/broadcast/${template.Uuid}/messages`);
                }}
              >
                <BroadcastTemplateCard
                  template={template}
                  isSelected={selectedTemplate?.Uuid === template.Uuid}
                  onSelect={() => setSelectedTemplate(template)}
                />
              </div>
            ))}
          </div>
          <MyPagination
            total={totalResults}
            onPaginate={(page, perPage) => setPagination({ page, perPage })}
          />
        </Col>
        <div className="col-lg-1"></div>
        <Col className="fw-bold">
          {selectedTemplate && (
            <>
              About this template:
              <BroadcastTemplateDetails selectedTemplate={selectedTemplate} />
            </>
          )}
        </Col>
      </Row>
    </div>
  );
}
